import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {NzButtonModule} from 'ng-zorro-antd/button';
import {NzDropdownModule} from 'ng-zorro-antd/dropdown';
import {NzIconModule} from 'ng-zorro-antd/icon';
import {NzMenuModule} from 'ng-zorro-antd/menu';
import {TranslocoPipe} from '@jsverse/transloco';
import {I18nService} from '../../core/i18n/i18n.service';
import {AppLanguage} from '../../core/i18n/i18n.config';

@Component({
  selector: 'app-account-layout',
  imports: [
    RouterOutlet,
    NzButtonModule,
    NzDropdownModule,
    NzIconModule,
    NzMenuModule,
    TranslocoPipe,
  ],
  templateUrl: './account-layout.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './account-layout.component.scss',
})
export class AccountLayoutComponent {
  private readonly i18nService = inject(I18nService);

  protected readonly activeLanguage = this.i18nService.activeLanguage;
  protected readonly activeLanguageLabel = this.i18nService.activeLanguageLabel;
  protected readonly languageOptions = [
    {label: 'English', value: 'en-US'},
    {label: '简体中文', value: 'zh-CN'},
  ] as const;

  async onSwitchLanguage(language: AppLanguage) {
    await this.i18nService.setLanguage(language);
  }
}
